import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../../shared/utils/api.js'

// export const getAllActivity = createAsyncThunk('activity/fetch', async (_, { rejectWithValue }) => {
//   try {
//     const response = await api.get('/v1/activity')
//     return response.data
//   } catch (error) {
//     return rejectWithValue(error.response.data.message || error.message)
//   }
// })

export const getAllActivity = createAsyncThunk('activity/fetch', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/v1/activity-tracking') // Changed from /v1/activity
    return response.data
  } catch (error) {
    return rejectWithValue(error.response.data.message || error.message)
  }
})

export const swipeWithAction = createAsyncThunk('activity/swipeWithAction', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/v1/interested/swiped-with-action')
    
    return response.data
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message)
  }
})

export const swipeWithoutAction = createAsyncThunk('activity/swipeWithoutAction', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/v1/interested/swiped-without-action')
    
    return response.data
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message)
  }
})

// Activity Tracking Endpoints
export const createActivity = createAsyncThunk('activity/create', async (activityData, { rejectWithValue }) => {
  try {
    const response = await api.post('/v1/activity-tracking', activityData)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response.data.message || error.message)
  }
})

export const getActivityStats = createAsyncThunk('activity/stats', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/v1/activity-tracking/stats')
    return response.data
  } catch (error) {
    return rejectWithValue(error.response.data.message || error.message)
  }
})

export const createBulkActivities = createAsyncThunk(
  'activity/createBulk',
  async (activitiesData, { rejectWithValue }) => {
  try {
    const response = await api.post('/v1/activity-tracking/bulk', activitiesData)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response.data.message || error.message)
  }
})

export const searchActivities = createAsyncThunk('activity/search', async (searchParams, { rejectWithValue }) => {
  try {
    const response = await api.post('/v1/activity-tracking/search', searchParams)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response.data.message || error.message)
  }
})

export const getUserActivities = createAsyncThunk('activity/userActivities', async (userId, { rejectWithValue }) => {
  try {
    const response = await api.get(`/v1/activity-tracking/user/${userId}`)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response.data.message || error.message)
  }
})

export const getActivityById = createAsyncThunk('activity/getById', async (activityId, { rejectWithValue }) => {
  try {
    const response = await api.get(`/v1/activity-tracking/${activityId}`)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response.data.message || error.message)
  }
})

export const deleteActivity = createAsyncThunk('activity/delete', async (activityId, { rejectWithValue }) => {
  try {
    await api.delete(`/v1/activity-tracking/${activityId}`)
    return { id: activityId }
  } catch (error) {
    return rejectWithValue(error.response.data.message || error.message)
  }
})

// Get Recent Activities (Admin endpoint with pagination)
export const getRecentActivities = createAsyncThunk(
  'activity/recentActivities',
  async (params = {}, { rejectWithValue }) => {
    try {
      const { page = 1, limit = 10, date, userType, activityType } = params
      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
      })

      if (date) queryParams.append('date', date)
      if (userType) queryParams.append('userType', userType)
      if (activityType) queryParams.append('activityType', activityType)

      const response = await api.get(`/v1/admin/recent-activity?${queryParams.toString()}`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

// Get GDPR Consents (Admin endpoint)
export const getGdprConsents = createAsyncThunk(
  'activity/gdprConsents',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/v1/admin/gdpr/consents${userId ? `?userId=${userId}` : ''}`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)
